import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import "@arco-design/web-react/es/InputNumber/style";
import _InputNumber from "@arco-design/web-react/es/InputNumber";
import "@arco-design/web-react/es/Switch/style";
import _Switch from "@arco-design/web-react/es/Switch";
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useLocale from '../../utils/useLocale';
import styles from './style/block.module.less';
export default function Block(props) {
  const {
    title,
    options,
    children
  } = props;
  const locale = useLocale();
  const settings = useSelector(state => state.settings);
  const dispatch = useDispatch();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.block
  }, /*#__PURE__*/React.createElement("h5", {
    className: styles.title
  }, title), options && options.map(option => {
    const type = option.type || 'switch';
    return /*#__PURE__*/React.createElement("div", {
      className: styles['switch-wrapper'],
      key: option.value
    }, /*#__PURE__*/React.createElement("span", null, locale[option.name]), type === 'switch' && /*#__PURE__*/React.createElement(_Switch, {
      size: "small",
      checked: !!settings[option.value],
      onChange: checked => {
        const newSetting = {
          ...settings,
          [option.value]: checked
        };
        dispatch({
          type: 'update-settings',
          payload: {
            settings: newSetting
          }
        });
        // set color week
        if (checked && option.value === 'colorWeek') {
          document.body.style.filter = 'invert(80%)';
        }
        if (!checked && option.value === 'colorWeek') {
          document.body.style.filter = 'none';
        }
      }
    }), type === 'number' && /*#__PURE__*/React.createElement(_InputNumber, {
      style: {
        width: 80
      },
      size: "small",
      value: settings.menuWidth,
      onChange: value => {
        const newSetting = {
          ...settings,
          [option.value]: value
        };
        dispatch({
          type: 'update-settings',
          payload: {
            settings: newSetting
          }
        });
      }
    }));
  }), children, /*#__PURE__*/React.createElement(_Divider, null));
}